import Vue from 'vue';
import axios from 'axios';
import config from '@/config';
import store from '@/store';
import qs from 'qs';

class BaseService {
  static instance = null;

  static init() {
    if (!this.constructor.instance) {
      this.$http = axios.create({
        baseURL: `/api/v${config.api_version}`,
        headers: {
          'Content-Type': 'application/json',
        },
        validateStatus(status) {
          return status >= 200;
        },
      });

      this.$http.interceptors.request.use(config => {
        config.headers['Authorization'] = Vue.ls.get('token');
        return config;
      });
      this.$http.interceptors.response.use(
        response => response,
        error => {
          if (error.response) {
            if (error.response.status === 401) Vue.ls.remove('token');
          }
          return Promise.reject(error);
        }
      );

      this.constructor.instance = this;
    }

    return this.constructor.instance;
  }

  responseHandler = response => {
    const { status, statusText, data } = response;
    if (status >= 200 && status < 300) {
      // If response status is 200 and body is empty.
      if (status === 200) {
        if (typeof data === 'string' && data.trim().length === 0) {
          return true;
        }
        if (
          typeof data === 'object' &&
          !Array.isArray(data) &&
          Object.keys(data).length === 0
        ) {
          return true;
        }
      }
      return data;
    }
    if (status === 401) {
      // If Unauthorized we logout user and remove all user data
      store.dispatch('userLogout');
    }
    throw (data && (data.message || data.reason)) ||
      statusText ||
      'Generic error';
  };

  get = async (url, query) => {
    try {
      const qString = query ? `?${qs.stringify(query, { encode: true })}` : '';
      const result = await this.$http.get(url + qString);
      return this.responseHandler(result);
    } catch (err) {
      throw new Error(err);
    }
  };

  post = async (url, data) => {
    try {
      const result = await this.$http.post(url, data);
      return this.responseHandler(result);
    } catch (err) {
      throw new Error(err);
    }
  };

  put = async (url, data) => {
    try {
      const result = await this.$http.put(url, data);
      return this.responseHandler(result);
    } catch (err) {
      throw new Error(err);
    }
  };

  delete = async url => {
    try {
      const result = await this.$http.delete(url);
      if (result.status === 204) {
        return true;
      }
      return this.responseHandler(result);
    } catch (err) {
      throw new Error(err);
    }
  };
}

export default BaseService;
